


















import { Vue, Component, Mixins, Prop } from "vue-property-decorator";
import VueElementLoading from 'vue-element-loading'; // https://www.npmjs.com/package/vue-element-loading
import { AA } from "@/lib/mixin";
import SearchInput from '@/components/kbSearchInput.vue'
import ArticleList from '@/components/ArticleList.vue';
import { articleSearch } from '@/shared/api';
import { aplusButtonClick } from "@/lib/qtLIb" 

const CACHE_KEYWORD_PREFIX = 'KB_CACHE_KEYWORD_'
const CACHE_SEARCH_INFO = 'KB_CACHE_SEARCH_INFO'

@Component({
  components: { VueElementLoading, ArticleList, SearchInput }
})
export default class KBSearch extends Mixins(Vue, AA) {
  @Prop(String) readonly catalogId!: number;
  @Prop(String) readonly tabIndex!: number;

  articles: Array<Article> = [];
  isActive = false;
  keyword = ''
  historyWords: string[]=[]
  fromHistory = false

  // 获取当前catalogName用于上报
  get currentCatalogName(): string {
    const currentTabData = this.$store.getters.catalogs.find((tab: any) => tab.name === 'tab-' + this.tabIndex);
    const currentCatalog = currentTabData?.catalogs?.find((c: any) => c.id === Number(this.catalogId));
    return currentCatalog ? currentCatalog.title : '';
  }

  getData() {
    this.isActive = true
    return articleSearch(this.catalogId, this.keyword).then(res => {
      this.articles = res
      }).catch(err => {
      console.log('KB search Error: ', err);
    }).finally(() => {
      this.isActive = false;
    });
  }

  mounted() {
    const cacheSearchKeywords = localStorage.getItem(CACHE_KEYWORD_PREFIX + this.catalogId)
    if (cacheSearchKeywords) {
      const parsedKeywords = JSON.parse(cacheSearchKeywords)
      this.historyWords = parsedKeywords
    }
    const cachedSearchInfo = sessionStorage.getItem(CACHE_SEARCH_INFO)
    if (cachedSearchInfo) {
      const info = JSON.parse(cachedSearchInfo)
      if (info.keyword) {
        this.keyword = info.keyword
        this.getData()
        .then(() => {
          (this.$refs.content as HTMLElement).scrollTo({ top: Number(info.top), behavior: 'smooth' });
          sessionStorage.removeItem(CACHE_SEARCH_INFO)
        })
      }
    }
  }

  handleSearch(keyword: string, fromHistory = false) {
    this.keyword = keyword
    this.fromHistory = fromHistory
    
    // 只有当关键词不为空时才保存到历史记录
    if (keyword) {
      const index = this.historyWords.indexOf(keyword)
      if (index !== -1) {
        this.historyWords.splice(index, 1)
      }
      this.historyWords.unshift(keyword)
      if (this.historyWords.length >= 20) {
        this.historyWords = this.historyWords.slice(0, 20)
      }
      localStorage.setItem(CACHE_KEYWORD_PREFIX + this.catalogId, JSON.stringify(this.historyWords))

      // 添加搜索事件上报
      const eventName = Number(this.tabIndex) === 0 ? 'sllp_search_confirm_clk' : 'selp_search_confirm_clk'
      window.console.log('eventName:', eventName)
      aplusButtonClick({
        // eslint-disable-next-line @typescript-eslint/camelcase
        event_name: eventName,
        // eslint-disable-next-line @typescript-eslint/camelcase
        search_contents: keyword,
        // eslint-disable-next-line @typescript-eslint/camelcase
        search_type: fromHistory ? '历史搜索' : '搜索框搜索',
        // eslint-disable-next-line @typescript-eslint/camelcase
        current_category: this.currentCatalogName
      })

      this.getData()
    } else {
      this.articles = []
    }
  }

  viewKBItem (item: any) {
    console.log(item)
    sessionStorage.setItem(CACHE_SEARCH_INFO, JSON.stringify({keyword: this.keyword, top: (this.$refs.content as HTMLElement).scrollTop}))
  }

  clearAllKeywords () {
    this.historyWords = []
    localStorage.removeItem(CACHE_KEYWORD_PREFIX + this.catalogId)
  }
}
